







































































































































import leftCarousel from '../../components/left-carousel.vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component({
  name: 'home',
  components: {
    leftCarousel
  }
})
export default class home extends Vue {
  member: any = ''
  department: any = ''
  optionsOfMember: Array<Object> = [
    {
      value: 'http://www.allianz.com',
      keyCn: '安联',
      keyEn: 'Allianz'
    },
    {
      value: 'http://www.pwc.com',
      keyCn: '普华永道',
      keyEn: 'PwC'
    },
    {
      value: 'http://www.toshiba.co.jp',
      keyCn: '东芝',
      keyEn: 'TOSHIBA'
    },
    {
      value: 'http://www.abb.com',
      keyCn: 'ABB',
      keyEn: 'ABB'
    },
    {
      value: 'http://www.aig.com',
      keyCn: '美国国际集团',
      keyEn: 'AIG'
    },
    {
      value: 'http://www.bain.com',
      keyCn: '贝恩公司',
      keyEn: 'Bain & Company'
    },
    {
      value: 'http://www.bekaert.com',
      keyCn: '贝卡尔特',
      keyEn: 'BEKAERT'
    },
    {
      value: 'http://www.bnpparibas.com',
      keyCn: '法国巴黎银行',
      keyEn: 'BNP PARIBAS'
    },
    {
      value: 'http://www.cpgroupglobal.com',
      keyCn: '正大集团',
      keyEn: 'C.P. Group'
    },
    {
      value: 'https://continentalgrain.com/',
      keyCn: '康地谷物',
      keyEn: 'CGC'
    },
    {
      value: 'http://www.danone.com',
      keyCn: '达能',
      keyEn: 'Danone'
    },
    {
      value: 'http://www.engie.com',
      keyCn: '法能',
      keyEn: 'ENGIE'
    },
    {
      value: 'https://www.ey.com/en_gl',
      keyCn: '安永',
      keyEn: 'EY'
    },
    {
      value: 'https://www.fcagroup.com/en-US/pages/home.aspx',
      keyCn: '菲克集团',
      keyEn: 'FCA'
    },
    {
      value: 'https://www.gm.com ',
      keyCn: '通用汽车',
      keyEn: 'GM'
    },
    {
      value: 'https://www.hsbc.com/',
      keyCn: '汇丰',
      keyEn: 'HSBC'
    },
    {
      value: 'http://www.infosys.com',
      keyCn: '印孚瑟斯',
      keyEn: 'Infosys'
    },
    {
      value: 'http://www.investorab.com',
      keyCn: '银瑞达',
      keyEn: 'Investor AB'
    },
    {
      value: 'http://www.swire.com',
      keyCn: '太古',
      keyEn: 'JSS'
    },
    {
      value: 'http://www.manulife.com',
      keyCn: '宏利金融',
      keyEn: 'Manulife Financial'
    },
    {
      value: 'http://www.metroag.de',
      keyCn: '麦德龙集团',
      keyEn: 'METRO AG'
    },
    {
      value: 'http://www.mitsubishicorp.com',
      keyCn: '三菱商事',
      keyEn: 'Mitsubishi Corporation'
    },
    {
      value: 'http://www.nomura.com',
      keyCn: '野村控股',
      keyEn: 'NOMURA'
    },
    {
      value: 'http://www.novartis.com',
      keyCn: '诺华',
      keyEn: 'Novartis'
    },
    {
      value: 'http://www.prudential.co.uk',
      keyCn: '英国保诚',
      keyEn: 'Prudential'
    },
    {
      value: 'https://www.roche.com',
      keyCn: '罗氏',
      keyEn: 'Roche'
    },
    {
      value: 'https://www.vopak.com/',
      keyCn: '孚宝',
      keyEn: 'Vopak'
    },
    {
      value: 'https://www.se.com',
      keyCn: '施耐德电气',
      keyEn: 'Schneider Electric'
    },
    {
      value: 'http://www.siemens.com',
      keyCn: '西门子',
      keyEn: 'Siemens'
    },
    {
      value: 'https://www.starrcompanies.com/',
      keyCn: '史带集团',
      keyEn: 'Starr'
    },
    {
      value: 'https://www.smfg.co.jp/english/',
      keyCn: '三井住友金融集团',
      keyEn: 'SMFG'
    },
    {
      value: 'http://www.swissre.com',
      keyCn: '瑞士再保险',
      keyEn: 'Swiss Re'
    },
    {
      value: 'http://www.telstra.com.au',
      keyCn: '澳大利亚电信',
      keyEn: 'Telstra'
    },
    {
      value: 'http://www.thyssenkrupp.com',
      keyCn: '蒂森克虏伯',
      keyEn: 'thyssenkrupp'
    },
    {
      value: 'http://www.tishmanspeyer.com',
      keyCn: '铁狮门',
      keyEn: 'TS'
    },
    {
      value: 'http://www.wpp.com',
      keyCn: 'WPP',
      keyEn: 'WPP'
    }
  ]

  optionsOfDepartments: Array<Object> = [
    {
      value: 'http://wsb.sh.gov.cn',
      keyCn: '上海市人民政府外事办公室',
      keyEn: `Foreign Affairs Office of the Shanghai Municipal People's Government`
    },
    {
      value: 'http://fgw.sh.gov.cn/',
      keyCn: '上海市发展和改革委员会',
      keyEn: `Shanghai Municipal Development & Reform Commission`
    },
    {
      value: 'http://sww.sh.gov.cn/',
      keyCn: '上海市商务委员会',
      keyEn: `Shanghai Municipal Commission of Commerce`
    },
    {
      value: 'http://www.shio.gov.cn/',
      keyCn: '上海市人民政府新闻办公室',
      keyEn: `Information Office of Shanghai Municipality`
    },
    {
      value: 'http://www.siis.org.cn/',
      keyCn: '上海国际问题研究院',
      keyEn: `Shanghai Institutes for International Studies`
    }
  ]

  currentIndex: number = 1
  peopleCnList: Array<Object> = [
    {
      title: '主席欢迎辞',
      name: '迈克尔<span style="font-family: Times New Roman">·</span>狄克曼',
      imgurl: require('../../../assets/iblac/home/chairman.jpg'),
      messages: `<p>欢迎来到上海市市长国际企业家咨询会议（IBLAC）！</p>
                <p>IBLAC会议起始于1989年，由当时的上海市长——尊敬的朱镕基先生主持召开。去年是IBLAC的三十周年纪念，也标志着中国的改革开放进入第四十年。中国走过了一段漫长的旅程，值得强调的是，上海致力于建设成为中国的国际经济中心、金融中心...</p>`,
      prod: 'chairman'
    },
    {
      title: '主旨演讲人',
      name: '弗朗西斯<span style="font-family: Times New Roman">·</span>高锐',
      imgurl: require('../../../assets/iblac/home/speeker.jpg'),
      messages: `<p>1951年出生，澳大利亚国民。剑桥大学博士学位。</p>
                <p>现为世界知识产权组织总干事秘书长，国际保护植物新品种联盟(UPOV)秘书长。联合国系统行政首长协调委员(CEB)高级别管理委员会(HLCM)主席(2012年至今)，日内瓦国际咨询委员会委员。</p>
                <p>在墨尔本(1974-1976年)和悉尼(1984年)从事...</p>`,
      prod: 'speeker1'
    },
    {
      title: '主旨演讲人',
      name: '格雷格<span style="font-family: Times New Roman">·</span>克拉克',
      imgurl: require('../../../assets/iblac/home/speeker2.png'),
      messages: `<p>大英帝国司令勋章，英国社会科学院院士。教育背景：温布尔登学院（1975-1980）、剑桥大学（1981-1986）、哥伦比亚大学城市与区域发展研究员（1994-1966）、伦敦政治经济学院研究学者（1997-1999）。</p>
                <p>现任汇丰银行全球银行业务与市场部未来城市与新兴产业高级顾问兼副主席（2018年-至今）...</p>`,
      prod: 'speeker2'
    }
  ]

  peopleEnList: Array<Object> = [
    {
      title: 'Welcome speech by the chairman',
      name: 'Mr. Michael Diekmann',
      imgurl: require('../../../assets/iblac/home/chairman.jpg'),
      messages: `<p>Welcome to the 2019 meeting of the International Business Leaders’ Advisory Council for the Mayor of Shanghai (IBLAC)!</p>
                <p>Last year marked the 30th anniversary of IBLAC which was established in 1989 by the former Shanghai Mayor honorable Zhu Rongji and it also marked the 40th anniversary of China . . .</p>`,
      prod: 'chairman'
    },
    {
      title: 'Keynote speaker',
      name: 'Francis Gurry',
      imgurl: require('../../../assets/iblac/home/speeker.jpg'),
      messages: `<p>Francis Gurry is an Australian lawyer who has served as Director General of the World Intellectual Property Organization (WIPO) since October 1, 2008.</p>
                <p>He holds law degrees from the University of Melbourne, a Ph.D from the University of Cambridge and is an honorary professor of, and holds...</p>`,
      prod: 'speeker1'
    },
    {
      title: 'Keynote speaker',
      name: 'Greg Clark',
      imgurl: require('../../../assets/iblac/home/speeker2.png'),
      messages: `<p class="content">CEB, FAcSS</p><p>Education: Wimbledon College (1975—1980), Cambridge University (1981—1986), Columbia University Urban and Regional Development Researcher (1994—1966), London School of Economics and Political Science (1997—1999).</p>`,
      prod: 'speeker2'
    }
  ]
  get peopleList(): Array<Object> {
    return this.isCn ? this.peopleCnList : this.peopleEnList
  }
  newsList: Array<Object> = [{ title: '第三十一次上海市市长会议', url: '' }, { title: '第三十二次上海市市长会议', url: '' }, { title: '第三十三次上海市市长会议', url: '' }, { title: '第三十四次上海市市长会议', url: '' }, { title: '第三十五次上海市市长会议', url: '' }]
  imgList: Array<Object> = [
    {
      id: 1,
      title: '我是一',
      url: require('../../../assets/iblac/home/banner1.png')
    },
    {
      id: 2,
      title: '我是二',
      url: require('../../../assets/iblac/home/banner4.png')
    }
  ]
  selectChang(value: any) {
    window.open(value)
  }

  get isCn(): boolean {
    return this.$store.getters.i18nLocale === 'us' ? false : true
  }

  // mounted() {
  //   // this.axios.get('/iblac/upload/data')
  // }
}
